import { captureException } from '@sentry/react'
import { type UseQueryOptions, useQuery } from '@tanstack/react-query'
import {
	type HttpGetServiceGalleryImagesOptions,
	HttpGetServiceGalleryImagesResponse,
	httpGetServiceGalleryImages
} from '@/features/service-vetting/http/services-vetting.http.ts'
import { parseAxiosPromise } from '@/helpers/utils'
import { QUERY_KEYS } from '@/query-client'

export const useGetGalleryImages = (
	urlParams: HttpGetServiceGalleryImagesOptions['urlParams'],
	options?: Omit<
		UseQueryOptions<HttpGetServiceGalleryImagesResponse>,
		'queryFn' & 'queryKey'
	>
) => {
	return useQuery({
		...options,
		queryKey: [QUERY_KEYS.SERVICE_GALLERY_IMAGES, urlParams.serviceId],
		queryFn: () =>
			parseAxiosPromise({
				axiosPromise: httpGetServiceGalleryImages({
					urlParams,
					params: { response_type: 'extended' }
				}),
				responseShape: HttpGetServiceGalleryImagesResponse,
				onZodError: captureException
			})
	})
}
